import { Partial } from '@40seas/entities/common';
import { CreateRefundDto } from './create.refund.dto';

export class UpdateRefundDto extends Partial(CreateRefundDto) {}
